import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'
import type { InventoryMapGeometry } from '@/widgets/InventoryMap'

export const useRelocateInventoryObject = () => {
  const http = useHttp()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: { object_id: number; geometry: InventoryMapGeometry }) =>
      http.put(`/api/v1/objects/${data.object_id}/geometry`, { geometry: data.geometry }),
  })

  const relocate = async (data: { object_id: number; geometry: InventoryMapGeometry }) => {
    try {
      await mutation.mutateAsync(data)
    } catch (error: any) {
      addError(
        trs(
          error?.response?.data?.data?.msg ||
            error?.response?.data?.error ||
            'request.unknown_error',
        ),
      )
    }
  }

  return {
    ...mutation,

    relocate,
  }
}
